<ng-container *ngTemplateOutlet="skeletonOrderDetail"></ng-container>

<ng-template #skeletonOrderDetail>
  <!-- Header: order code, order date, status badge — the same three-item row
       the loaded page draws in its card-header. -->
  <div class="card-header align-items-center gap-4 py-5">
    <div class="skeleton h-20px w-200px"></div>
    <div class="skeleton h-20px w-175px"></div>
    <div class="skeleton h-30px w-110px"></div>
  </div>

  <div class="card-body d-flex p-0">
    <div class="col-12 d-flex flex-column flex-lg-row flex-1">
      <!-- Left: transaction summary — price rows, sub-total, the bank tiles,
           slip upload and the two action buttons. -->
      <div class="col-12 col-lg-4 order-2 order-lg-1 p-9 border-end">
        <div class="skeleton h-30px w-150px mb-8"></div>

        <div class="d-flex flex-stack mb-4">
          <div class="skeleton h-20px w-100px"></div>
          <div class="skeleton h-20px w-80px"></div>
        </div>
        <div class="d-flex flex-stack mb-4">
          <div class="skeleton h-20px w-125px"></div>
          <div class="skeleton h-20px w-60px"></div>
        </div>
        <div class="separator my-4"></div>
        <div class="d-flex flex-stack mb-10">
          <div class="skeleton h-25px w-90px"></div>
          <div class="skeleton h-30px w-120px"></div>
        </div>

        <div class="skeleton h-20px w-150px mb-5"></div>
        <div class="d-flex flex-column gap-4">
          <div class="skeleton h-60px w-100"></div>
          <div class="skeleton h-60px w-100"></div>
          <div class="skeleton h-60px w-100"></div>
        </div>

        <div class="skeleton h-20px w-120px mt-10 mb-4"></div>
        <div class="skeleton h-100px w-100 mb-5"></div>
        <div class="skeleton h-40px w-100 mb-3"></div>
        <div class="skeleton h-40px w-100"></div>
      </div>

      <!-- Right: the ordered courses. -->
      <div
        class="col-12 col-lg-8 order-1 order-lg-2 p-9 border-bottom border-lg-none"
      >
        <div class="skeleton h-30px w-125px mb-8"></div>
        <ng-container *ngTemplateOutlet="skeletonOrderItem"></ng-container>
        <div class="separator my-8"></div>
        <ng-container *ngTemplateOutlet="skeletonOrderItem"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #skeletonOrderItem>
  <div
    class="d-flex flex-column flex-sm-row align-items-stretch gap-4 mb-4"
  >
    <div class="skeleton w-125px h-100px"></div>
    <div class="d-flex flex-row flex-grow-1 justify-content-between gap-4">
      <div class="d-flex flex-column gap-3 flex-grow-1">
        <div class="skeleton h-20px w-75"></div>
        <div class="skeleton h-15px w-50"></div>
        <div class="skeleton h-20px w-80px"></div>
      </div>
      <div class="d-flex flex-column align-items-end gap-3 ps-4">
        <div class="skeleton h-20px w-70px"></div>
        <div class="skeleton h-20px w-40px"></div>
      </div>
    </div>
  </div>
</ng-template>
